<template>
    <div class="popup-content">
      <router-view />
    </div>
</template>